export const drumTypeWhenNoCableSpoolingStorage = 'Storage reel';
